// Aba de bosses (aprovada pelo Arthur): salas com teleporte e cooldown; o bosstiário conta os abates.
// Atributos, ataques e loot oficiais (Canary). Level recomendado escolhido por nós; cooldown de 20 horas, como a maioria dos bosses do Tibia.
export interface BossDef { name: string; level: number; /** categoria oficial do bosstiário (Canary); sem ela, vem do level */ cat?: BossCat }
export const BOSSES: BossDef[] = [
  { name: 'The Horned Fox', level: 20 }, { name: 'Dharalion', level: 30 }, { name: 'Necropharus', level: 40 },
  { name: 'Grand Mother Foulscale', level: 50 }, { name: 'White Pale', level: 60 }, { name: 'Grorlam', level: 70 },
  { name: 'The Old Widow', level: 80 }, { name: 'Demodras', level: 100 }, { name: 'The Many', level: 110 },
  { name: 'Yakchal', level: 120 }, { name: 'Leviathan', level: 130 }, { name: 'Countess Sorrow', level: 150 },
  { name: 'The Plasmother', level: 160 }, { name: 'Dracola', level: 180 }, { name: 'Tyrn', level: 200 },
  { name: 'Orshabaal', level: 250 }, { name: 'Zulazza the Corruptor', level: 300 }, { name: 'Morgaroth', level: 350 },
  { name: 'Ghazbaran', level: 400 }, { name: 'Ferumbras', level: 450 }, { name: 'Scarlett Etzel', level: 500 },
  { name: 'Drume', level: 600 }, { name: 'The Time Guardian', level: 700 }, { name: "Goshnar's Malice", level: 900 },
  { name: 'The Brainstealer', level: 1200 }, { name: 'Magma Bubble', level: 1500 }, { name: 'The Monster', level: 2000 },
  { name: "Gaz'Haragoth", level: 2500 },
  // Make Believe Quest (Tibia 15.30): luta com fases, Rivais e dificuldade escolhida antes de entrar (wiki: level mínimo 300, recomendado 800)
  { name: 'Phosphorus', level: 300, cat: 'nemesis' },
  // --- demais bosses do bosstiário do Tibia (Canary: bossRace), level recomendado pela vida (1,35 × √vida) ---
  { name: "Captain Jones", level: 30, cat: "nemesis" },
  { name: "Dirtbeard", level: 30, cat: "bane" },
  { name: "Ekatrix", level: 30, cat: "archfoe" },
  { name: "Foreman Kneebiter", level: 30, cat: "nemesis" },
  { name: "General Murius", level: 30, cat: "nemesis" },
  { name: "Hairman the Huge", level: 30, cat: "nemesis" },
  { name: "Yaga the Crone", level: 30, cat: "nemesis" },
  { name: "Boogey", level: 40, cat: "bane" },
  { name: "Diseased Bill", level: 40, cat: "bane" },
  { name: "Diseased Dan", level: 40, cat: "bane" },
  { name: "Diseased Fred", level: 40, cat: "bane" },
  { name: "Glitterscale", level: 40, cat: "bane" },
  { name: "Heoni", level: 40, cat: "bane" },
  { name: "Monstor", level: 40, cat: "bane" },
  { name: "Ocyakao", level: 40, cat: "nemesis" },
  { name: "Raxias", level: 40, cat: "nemesis" },
  { name: "Arachir the Ancient One", level: 50, cat: "nemesis" },
  { name: "Bibby Bloodbath", level: 50, cat: "archfoe" },
  { name: "Diblis the Fair", level: 50, cat: "nemesis" },
  { name: "Evil Mastermind", level: 50, cat: "bane" },
  { name: "Hirintror", level: 50, cat: "nemesis" },
  { name: "Sir Valorcrest", level: 50, cat: "nemesis" },
  { name: "The Evil Eye", level: 50, cat: "nemesis" },
  { name: "Warlord Ruzad", level: 50, cat: "nemesis" },
  { name: "Zevelon Duskbringer", level: 50, cat: "nemesis" },
  { name: "Black Knight", level: 60, cat: "bane" },
  { name: "Dreadmaw", level: 60, cat: "nemesis" },
  { name: "Grandfather Tridian", level: 60, cat: "nemesis" },
  { name: "Kroazur", level: 70, cat: "bane" },
  { name: "Mad Mage", level: 70, cat: "bane" },
  { name: "Black Vixen", level: 80, cat: "archfoe" },
  { name: "Gravelord Oshuran", level: 80, cat: "nemesis" },
  { name: "Mahrdis", level: 80, cat: "bane" },
  { name: "Raging mage", level: 80, cat: "archfoe" },
  { name: "Rahemos", level: 80, cat: "bane" },
  { name: "Sharpclaw", level: 80, cat: "archfoe" },
  { name: "Battlemaster Zunzu", level: 90, cat: "nemesis" },
  { name: "Darkfang", level: 90, cat: "archfoe" },
  { name: "Dipthrah", level: 90, cat: "bane" },
  { name: "Morguthis", level: 90, cat: "bane" },
  { name: "Omruc", level: 90, cat: "bane" },
  { name: "Thalas", level: 90, cat: "bane" },
  { name: "Vashresamun", level: 90, cat: "bane" },
  { name: "Ashmunrah", level: 100, cat: "bane" },
  { name: "Bloodback", level: 100, cat: "archfoe" },
  { name: "Fleshslicer", level: 100, cat: "bane" },
  { name: "Horestis", level: 100, cat: "nemesis" },
  { name: "Shadowpelt", level: 100, cat: "archfoe" },
  { name: "Sugar Mommy", level: 100, cat: "bane" },
  { name: "The Voice of Ruin", level: 100, cat: "nemesis" },
  { name: "Zarabustor", level: 100, cat: "nemesis" },
  { name: "Katex Blood Tongue", level: 110, cat: "archfoe" },
  { name: "Srezz Yellow Eyes", level: 110, cat: "archfoe" },
  { name: "Utua Stone Sting", level: 110, cat: "archfoe" },
  { name: "Yirkas Blue Scales", level: 110, cat: "archfoe" },
  { name: "Lord of the Elements", level: 120, cat: "archfoe" },
  { name: "Ahau", level: 130, cat: "archfoe" },
  { name: "Sugar Daddy", level: 130, cat: "bane" },
  { name: "Dazed Leaf Golem", level: 140, cat: "bane" },
  { name: "Gelidrazah the Frozen", level: 140, cat: "archfoe" },
  { name: "Kalyassa", level: 140, cat: "archfoe" },
  { name: "Tazhadur", level: 140, cat: "archfoe" },
  { name: "The Blazing Rose", level: 140, cat: "archfoe" },
  { name: "Zorvorax", level: 140, cat: "archfoe" },
  { name: "Dreadful Disruptor", level: 160, cat: "nemesis" },
  { name: "Chizzoron the Distorter", level: 170, cat: "nemesis" },
  { name: "Grand Canon Dominus", level: 170, cat: "bane" },
  { name: "Preceptor Lazare", level: 170, cat: "bane" },
  { name: "The Imperor", level: 170, cat: "nemesis" },
  { name: "Zushuka", level: 170, cat: "nemesis" },
  { name: "Grand Chaplain Gaunder", level: 180, cat: "bane" },
  { name: "Grand Commander Soeren", level: 180, cat: "bane" },
  { name: "Chikhaton", level: 190, cat: "nemesis" },
  { name: "The Diamond Blossom", level: 190, cat: "archfoe" },
  { name: "The Handmaiden", level: 190, cat: "nemesis" },
  { name: "The Lily of Night", level: 190, cat: "archfoe" },
  { name: "Mr. Punish", level: 200, cat: "nemesis" },
  { name: "Furyosa", level: 210, cat: "nemesis" },
  { name: "Irgix The Flimsy", level: 210, cat: "archfoe" },
  { name: "Latrivan", level: 210, cat: "bane" },
  { name: "Sister Hetai", level: 210, cat: "archfoe" },
  { name: "Thawing Dragon Lord", level: 210, cat: "bane" },
  { name: "The Welter", level: 210, cat: "nemesis" },
  { name: "World Devourer", level: 210, cat: "nemesis" },
  { name: "Amenef the Burning", level: 220, cat: "archfoe" },
  { name: "Hellgorak", level: 220, cat: "bane" },
  { name: "Mozradek", level: 230, cat: "bane" },
  { name: "Neferi the Spy", level: 230, cat: "archfoe" },
  { name: "Tanjis", level: 230, cat: "bane" },
  { name: "Unaz the Mean", level: 230, cat: "archfoe" },
  { name: "Xogixath", level: 230, cat: "bane" },
  { name: "Massacre", level: 240, cat: "nemesis" },
  { name: "Ushuriel", level: 240, cat: "bane" },
  { name: "Vok the Freakish", level: 240, cat: "archfoe" },
  { name: "Faceless Bane", level: 250, cat: "archfoe" },
  { name: "Obujos", level: 250, cat: "bane" },
  { name: "Bragrumol", level: 260, cat: "bane" },
  { name: "Golgordan", level: 270, cat: "bane" },
  { name: "Shulgrax", level: 270, cat: "archfoe" },
  { name: "Annihilon", level: 290, cat: "bane" },
  { name: "Custodian", level: 290, cat: "bane" },
  { name: "Mawhawk", level: 290, cat: "archfoe" },
  { name: "Brokul", level: 300, cat: "archfoe" },
  { name: "Gaffir", level: 300, cat: "bane" },
  { name: "The First Dragon", level: 300, cat: "nemesis" },
  { name: "The Pale Count", level: 300, cat: "nemesis" },
  { name: "The Ravager", level: 310, cat: "bane" },
  { name: "Guard Captain Quaid", level: 320, cat: "bane" },
  { name: "Lisa", level: 320, cat: "bane" },
  { name: "Glooth Fairy", level: 330, cat: "bane" },
  { name: "Grand Master Oberon", level: 330, cat: "archfoe" },
  { name: "Death Priest Shargon", level: 340, cat: "bane" },
  { name: "Lloyd", level: 340, cat: "archfoe" },
  { name: "Bullwark", level: 360, cat: "bane" },
  { name: "Melting Frozen Horror", level: 360, cat: "archfoe" },
  { name: "Count Vlarkorth", level: 370, cat: "archfoe" },
  { name: "Duke Krule", level: 370, cat: "archfoe" },
  { name: "Earl Osam", level: 370, cat: "archfoe" },
  { name: "Madareth", level: 370, cat: "bane" },
  { name: "Sir Baeloc", level: 370, cat: "archfoe" },
  { name: "Sir Nictros", level: 370, cat: "archfoe" },
  { name: "Timira the Many-Headed", level: 370, cat: "archfoe" },
  { name: "Jaul", level: 400, cat: "bane" },
  { name: "Professor Maxxen", level: 400, cat: "bane" },
  { name: "The Enraged Thorn Knight", level: 400, cat: "archfoe" },
  { name: "Zugurosh", level: 410, cat: "bane" },
  { name: "Deep Terror", level: 430, cat: "bane" },
  { name: "Urmahlullu the Weakened", level: 430, cat: "archfoe" },
  { name: "Ascending Ferumbras", level: 520, cat: "nemesis" },
  { name: "Lady Tenebris", level: 520, cat: "archfoe" },
  { name: "Soul of Dragonking Zyrtarch", level: 520, cat: "archfoe" },
  { name: "Deathstrike", level: 600, cat: "archfoe" },
  { name: "Mitmah Vanguard", level: 600, cat: "archfoe" },
  { name: "Ratmiral Blackwhiskers", level: 630, cat: "archfoe" },
  { name: "The Shatterer", level: 630, cat: "bane" },
  { name: "Essence of Malice", level: 680, cat: "archfoe" },
  { name: "Gnomevil", level: 680, cat: "archfoe" },
  { name: "The Unarmored Voidborn", level: 680, cat: "archfoe" },
  { name: "Ragiaz", level: 710, cat: "archfoe" },
  { name: "Anomaly", level: 730, cat: "archfoe" },
  { name: "Eradicator", level: 730, cat: "archfoe" },
  { name: "Eradicator2", level: 730, cat: "archfoe" },
  { name: "Mazoran", level: 730, cat: "archfoe" },
  { name: "Outburst", level: 730, cat: "archfoe" },
  { name: "Plagirath", level: 730, cat: "archfoe" },
  { name: "Razzagorn", level: 730, cat: "archfoe" },
  { name: "Rupture", level: 730, cat: "archfoe" },
  { name: "Tarbaz", level: 730, cat: "archfoe" },
  { name: "The Souldespoiler", level: 730, cat: "archfoe" },
  { name: "Ghulosh", level: 740, cat: "archfoe" },
  { name: "Gorzindel", level: 740, cat: "archfoe" },
  { name: "Goshnar's Cruelty", level: 740, cat: "archfoe" },
  { name: "Goshnar's Greed", level: 740, cat: "archfoe" },
  { name: "Goshnar's Hatred", level: 740, cat: "archfoe" },
  { name: "Goshnar's Spite", level: 740, cat: "archfoe" },
  { name: "Lokathmor", level: 740, cat: "archfoe" },
  { name: "Lord Azaram", level: 740, cat: "archfoe" },
  { name: "Mazzinor", level: 740, cat: "archfoe" },
  { name: "The Dread Maiden", level: 740, cat: "archfoe" },
  { name: "The False God", level: 740, cat: "archfoe" },
  { name: "The Fear Feaster", level: 740, cat: "archfoe" },
  { name: "The Unwelcome", level: 740, cat: "archfoe" },
  { name: "Zamulosh", level: 740, cat: "archfoe" },
  { name: "Alptramun", level: 760, cat: "nemesis" },
  { name: "Izcandar the Banished", level: 760, cat: "nemesis" },
  { name: "Malofur Mangrinder", level: 760, cat: "nemesis" },
  { name: "Maxxenius", level: 760, cat: "nemesis" },
  { name: "Plagueroot", level: 760, cat: "nemesis" },
  { name: "Omrafir", level: 770, cat: "nemesis" },
  { name: "Abyssador", level: 790, cat: "archfoe" },
  { name: "Chagorz", level: 800, cat: "archfoe" },
  { name: "Ichgahal", level: 800, cat: "nemesis" },
  { name: "Murcion", level: 800, cat: "nemesis" },
  { name: "The Baron from Below", level: 800, cat: "bane" },
  { name: "The Count of the Core", level: 800, cat: "bane" },
  { name: "The Duke of the Depths", level: 800, cat: "bane" },
  { name: "Vemiath", level: 800, cat: "archfoe" },
  { name: "Arbaziloth", level: 810, cat: "archfoe" },
  { name: "The Rootkraken", level: 810, cat: "archfoe" },
  { name: "The Pale Worm", level: 870, cat: "archfoe" },
  { name: "King Zelos", level: 940, cat: "archfoe" },
  { name: "The Mutated Pumpkin", level: 950, cat: "nemesis" },
  { name: "Goshnar's Megalomania Blue", level: 1060, cat: "nemesis" },
  { name: "Goshnar's Megalomania Green", level: 1060, cat: "nemesis" },
  { name: "Bakragore", level: 1100, cat: "nemesis" },
  { name: "The Abomination", level: 1170, cat: "nemesis" },
  { name: "The Last Lore Keeper", level: 1170, cat: "nemesis" },
  { name: "The Scourge of Oblivion", level: 1210, cat: "archfoe" },
  { name: "The Nightmare Beast", level: 1240, cat: "archfoe" },
  { name: "Ancient Spawn of Morgathla", level: 1280, cat: "archfoe" },
  { name: "Morshabaal", level: 1350, cat: "nemesis" },
];
export const BOSS_COOLDOWN_MS = 20 * 3600_000;
/** tentativas de boss por dia (decisão do Arthur, 13/10/2026): 10 free, 12 VIP; +5 por dia na loja */
export const BOSS_ATTEMPTS = { free: 10, vip: 12, buy: 5 } as const;
export const BOSS_BUY_PRICE = 25;   // Noxara Coins pelas +5 tentativas do dia (proposta)
/** Cooldown próprio do Tibia (aprovado pelo Arthur): os bosses de raid raríssimos do Global (Ferumbras, Gaz'Haragoth e os
 *  arquidemônios Orshabaal, Ghazbaran e Morgaroth) voltam em dias; as salas de boss do Tibia (Scarlett, Drume, Time Guardian,
 *  Goshnar's Malice, Brainstealer, Magma Bubble, The Monster...) e o resto, em 20 horas. */
export const BOSS_COOLDOWN_H: Record<string, number> = {
  Ferumbras: 14 * 24, "Gaz'Haragoth": 7 * 24, Orshabaal: 7 * 24, Ghazbaran: 7 * 24, Morgaroth: 7 * 24,
  Phosphorus: 68,   // wiki: 2 dias e 20 horas
};
export const bossCooldownMs = (name: string) => (BOSS_COOLDOWN_H[name] ?? 20) * 3600_000;
/** bosstiário do personagem: abates e quando pode enfrentar de novo */
export type Bosstiary = Record<string, { kills: number; next: number }>;

// Bosstiário (Summer Update 2022, valores do TibiaQA): categorias Bane, Archfoe e Nemesis com 3 níveis
// (Prowess, Expertise, Mastery). Cada nível dá Boss Points; os pontos aumentam o bônus de loot dos bosses nos Boss Slots.
// A categoria de cada boss foi escolhida pelo level recomendado; a curva do bônus (25% + 1% a cada 10 pontos, até 182%) é proposta.
export type BossCat = 'bane' | 'archfoe' | 'nemesis';
export const BOSS_CAT_NAMES: Record<BossCat, string> = { bane: 'Bane', archfoe: 'Archfoe', nemesis: 'Nemesis' };
export const bossCategory = (level: number): BossCat => (level >= 900 ? 'nemesis' : level >= 150 ? 'archfoe' : 'bane');
/** categoria do boss: a oficial do Tibia quando existe, senão pelo level */
export const catOf = (b: BossDef): BossCat => b.cat ?? bossCategory(b.level);
export const BOSS_TIERS: Record<BossCat, { kills: [number, number, number]; pts: [number, number, number] }> = {
  bane: { kills: [25, 100, 300], pts: [5, 15, 30] },
  archfoe: { kills: [5, 20, 60], pts: [10, 30, 60] },
  nemesis: { kills: [1, 3, 5], pts: [10, 30, 60] },
};
export const BOSS_STAGE_NAMES = ['—', 'Prowess', 'Expertise', 'Mastery'] as const;
export function bossStage(kills: number, cat: BossCat): number {
  const k = BOSS_TIERS[cat].kills;
  return kills >= k[2] ? 3 : kills >= k[1] ? 2 : kills >= k[0] ? 1 : 0;
}
export function bossPoints(list: Bosstiary): number {
  let t = 0;
  for (const b of BOSSES) {
    const cat = catOf(b), st = bossStage(list[b.name]?.kills ?? 0, cat);
    for (let i = 0; i < st; i++) t += BOSS_TIERS[cat].pts[i]!;
  }
  return t;
}
/** bônus de loot do Boss Slot (decisão do Arthur, 13/10/2026): de +25% até +82% no total (10% de chance vira no máximo 18,2%).
 *  Os Boss Points levam o bônus de +25% a +72% (1.551 pontos) e a Mastery do boss soma +10%. */
export const BOSS_LOOT_MAX = 82;
export const BOSS_LOOT_MASTERY = 10;
export const bossLootBonus = (points: number) => Math.min(BOSS_LOOT_MAX - BOSS_LOOT_MASTERY, 25 + Math.floor(points / 33));
/** espaços: o 1º com o primeiro Prowess, o 2º com 1.500 Boss Points */
export function bossSlotCount(list: Bosstiary): number {
  const any = BOSSES.some((b) => bossStage(list[b.name]?.kills ?? 0, catOf(b)) >= 1);
  return (any ? 1 : 0) + (bossPoints(list) >= 1500 ? 1 : 0);
}
/** abates que o boss do dia conta no bosstiário */
export const BOOSTED_BOSS_KILLS = 3;

/** sala própria de cada boss (tools/maps/boss_arenas.py), com o visual do lugar onde ele vive */
export const bossArenaMap = (name: string) => 'boss-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
